import React from 'react';

import { Colors } from 'enums/Colors';
import Symbol from 'assets/logotype/symbol.svg';

import styles from './FlowBackground.module.scss';

interface Props {
  backgroundColor?: Colors;
  symbolColor?: Colors;
}

export const FlowBackground: React.FC<Props> = ({
  backgroundColor = Colors.SkyBlue,
  symbolColor = Colors.DarkBlue,
  children,
}) => (
  <>
    <div
      className={styles.background}
      style={{ backgroundColor: `var(--color-${backgroundColor})` }}
    >
      <Symbol style={{ fill: `var(--color-${symbolColor})` }} />
    </div>
    {children}
  </>
);
